import { cookiePreferencesPortal } from "@design-system/atoms";
import { CookiePreferencesModal } from "@modules/cookies/components";
import { useCookieConsent } from "@modules/cookies/hooks";

export function CookiePreferencesPortal() {
  const { updateConsent } = useCookieConsent();

  const handleSave = (consent: any) => {
    updateConsent(consent);
  };

  return (
    <CookiePreferencesModal
      onSave={handleSave}
      onClose={() => cookiePreferencesPortal.change("opened", false)}
    />
  );
}
